/* istanbul ignore file */

import './polyfills';
import app from './app';
import katalReady from '@katal/components-ready';
import 'src/styles/app.scss';

katalReady(() => {
    app.run();
});
